// import React, { useState } from 'react'

import { Heading, Text } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'
import CurrentIcon from 'public/images/current-tool.svg'
import DoneIcon from 'public/images/done-tool.svg'
import NextIcon from 'public/images/next-tool.svg'

import { StyledRelationTool, StyledToolCard, StyledTitle } from './index.styled'

const RelationTool = () => {
  const { formatMessage: f } = useIntl()

  return (
    <StyledRelationTool>
      <StyledTitle>
        <Text size="c2" type="bold" color="#8C8C8C">
          {f({
            id: 'relationTool.title',
            defaultMessage: 'RELATED TOOLS',
          })}
        </Text>
      </StyledTitle>

      <div className="stepper-wrapper">
        <div className="stepper-item">
          <div className="step-counter">
            <div className="logoTracking">
              {' '}
              <DoneIcon />
            </div>
          </div>
          <StyledToolCard>
            <div className="logo">
              <img
                loading="lazy"
                src={`${assetImagePath}/due-date-last-period-icon.png`}
                alt=""
              />
            </div>
            <div className="title">
              <Heading tag="h6" as="h6" fontWeight="bold">
                Tool name
              </Heading>
            </div>
          </StyledToolCard>
        </div>
        <div className="stepper-item">
          <div className="step-counter">
            <div className="logoTracking">
              {' '}
              <DoneIcon />
            </div>
          </div>
          <StyledToolCard>
            <div className="logo">
              <img
                loading="lazy"
                src={`${assetImagePath}/due-date-last-period-icon.png`}
                alt=""
              />
            </div>
            <div className="title">
              <Heading tag="h6" as="h6" fontWeight="bold">
                Tool name
              </Heading>
            </div>
          </StyledToolCard>
        </div>
        <div className="stepper-item">
          <div className="step-counter">
            <div className="logoTracking">
              <NextIcon />
            </div>
          </div>
          <StyledToolCard>
            <div className="logo">
              <img
                loading="lazy"
                src={`${assetImagePath}/due-date-last-period-icon.png`}
                alt=""
              />
            </div>
            <div className="title">
              <Heading tag="h6" as="h6" fontWeight="bold">
                Tool name
              </Heading>
            </div>
          </StyledToolCard>
        </div>
        <div className="stepper-item">
          <div className="step-counter">
            <div className="logoTracking">
              {' '}
              <CurrentIcon />
            </div>
          </div>
          <StyledToolCard>
            <div className="logo">
              <img
                loading="lazy"
                src={`${assetImagePath}/due-date-last-period-icon.png`}
                alt=""
              />
            </div>
            <div className="title">
              <Heading tag="h6" as="h6" fontWeight="bold">
                Tool name
              </Heading>
            </div>
          </StyledToolCard>
        </div>
      </div>
    </StyledRelationTool>
  )
}

export { RelationTool }
